import { render } from "./DeliveryAddressPicker.vue?vue&type=template&id=f2e59982&scoped=true"
import script from "./DeliveryAddressPicker.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressPicker.vue?vue&type=script&lang=js"

import "./DeliveryAddressPicker.vue?vue&type=style&index=0&id=f2e59982&scoped=true&lang=css"
import "./DeliveryAddressPicker.vue?vue&type=style&index=1&id=f2e59982&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e59982"]])

export default __exports__